/* Cart drawer behaviour (Phase 2). think-crucial.js InlineCart owns open/close, every add, update and remove, and the
   contents refresh; this file only adds dialog behaviour on top: focus in/out and trap, Esc, live announcements,
   the quantity stepper, the dispatch clock, and one-tap adds for "You may also need". */
(function () {
  var root = document.querySelector('[data-tc-cd]');
  if (!root) { return; }
  var panel = root.querySelector('.tc-cd__panel');
  var body = root.querySelector('[data-tc-cd-body]');
  var live = root.querySelector('[data-tc-cd-live]');
  var shown = false, opener = null, lastCount = null, pendingMsg = '', pendingFocus = null, clock = null;

  function $q() { return window.jQuery; }
  function visible() { return root.classList.contains('active'); }
  function focusables() {
    var l = panel.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden]):not([disabled]),select,textarea,iframe,[tabindex]:not([tabindex="-1"])');
    var out = [];
    for (var i = 0; i < l.length; i++) { if (l[i].offsetWidth || l[i].offsetHeight || l[i].getClientRects().length) { out.push(l[i]); } }
    return out;
  }
  function announce(msg) {
    if (!live || !msg) { return; }
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 60);
  }

  /* Dispatch line: assets/tc-dispatch.js (shared with the product page; business days, USPS holidays 2026-2027).
     Until it has loaded, the server-rendered "Ships same business day when ordered by 2pm ET" stays. */
  function dispatchText(now) { return window.tcDispatch ? window.tcDispatch.text(now) : null; }
  function updateDispatch() {
    var el = body.querySelector('[data-tc-dispatch]');
    var t = el && dispatchText(new Date());
    if (t && el.textContent !== t) { el.textContent = t; }
  }

  /* Shop Pay in the drawer. Shopify only loads its wallet script on pages that server-render a checkout button (v2 product
     pages, /cart), so on other pages the drawer loads the same script itself, once, when it opens with items. The block keeps
     its 48 px from the start (no shift) and collapses if the button hasn't upgraded within 8 s. */
  var XP = 'shopify-accelerated-checkout-cart', xpAsked = false;
  function express() {
    if (!body.querySelector('[data-tc-cd-xp] ' + XP) || !window.customElements) { return; }
    if (customElements.get(XP)) { root.classList.add('xp-ready'); return; }
    if (xpAsked || !shown) { return; }
    xpAsked = true;
    var has = false, l = document.scripts;
    for (var i = 0; i < l.length; i++) { if (/portable-wallets/.test(l[i].src)) { has = true; } }
    if (!has) {
      var s = document.createElement('script');
      s.type = 'module'; s.crossOrigin = 'anonymous'; s.src = '/cdn/shopifycloud/portable-wallets/latest/portable-wallets.en.js';
      document.head.appendChild(s);
    }
    customElements.whenDefined(XP).then(function () { root.classList.add('xp-ready'); root.classList.remove('xp-failed'); });
    setTimeout(function () { if (!customElements.get(XP)) { root.classList.add('xp-failed'); } }, 8000);
  }

  function onOpen() {
    shown = true;
    var a = document.activeElement;
    opener = (a && a !== document.body && !panel.contains(a)) ? a : null;
    updateDispatch();
    if (!clock) { clock = setInterval(updateDispatch, 30000); }
    express();
    setTimeout(function () { try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); } }, 30);
  }
  function onClose() {
    shown = false;
    if (clock) { clearInterval(clock); clock = null; }
    var back = opener && document.documentElement.contains(opener) ? opener : document.querySelector('.inline-cart-trigger');
    opener = null;
    if (back && (panel.contains(document.activeElement) || document.activeElement === document.body)) {
      try { back.focus({ preventScroll: true }); } catch (e) {}
    }
  }
  function sync() {
    var v = visible();
    if (v && !shown) { onOpen(); } else if (!v && shown) { onClose(); }
  }
  if (window.MutationObserver) {
    new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ['class'] });
  }

  function close() {
    var x = panel.querySelector('.closer');
    if (x) { x.click(); }
  }
  document.addEventListener('keydown', function (e) {
    if (!shown) { return; }
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') { return; }
    var f = focusables();
    if (!f.length) { e.preventDefault(); panel.focus(); return; }
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (e.shiftKey && (a === first || a === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
    else if (!panel.contains(a)) { e.preventDefault(); first.focus(); }
  });
  document.addEventListener('focusin', function (e) {
    if (shown && !panel.contains(e.target) && !(e.target.closest && e.target.closest('dialog[open]'))) {
      try { panel.focus({ preventScroll: true }); } catch (x) {}
    }
  });

  function busy(on) {
    root.classList.toggle('is-busy', !!on);
    if (on) { panel.setAttribute('aria-busy', 'true'); } else { panel.removeAttribute('aria-busy'); }
  }
  /* An add from outside the drawer (product page, product cards) opens the drawer before its contents are refetched, so until
     the first refresh after the add completes, the drawer hides the old lines and subtotal instead of showing them. */
  var loading = false, addDone = false, loadTimer = null;
  function setLoading(on) {
    loading = !!on;
    root.classList.toggle('is-loading', loading);
    clearTimeout(loadTimer);
    if (loading) {
      addDone = false;
      busy(true);
      loadTimer = setTimeout(function () { setLoading(false); busy(false); }, 8000);
    }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.add-to-cart, a.add-cart');
    if (b && !b.disabled && !root.contains(b)) { setLoading(true); }
  }, true);
  (function bindDone() {
    if (!$q()) { window.addEventListener('load', bindDone, { once: true }); return; }
    $q()(document).on('cart.requestComplete', function () { if (loading) { addDone = true; } });
  })();
  function keyOf(el) { var it = el.closest('[data-tc-cd-key]'); return it ? it.getAttribute('data-tc-cd-key') : null; }

  root.addEventListener('click', function (e) {
    var step = e.target.closest('[data-tc-cd-step]');
    if (step && !step.disabled) {
      var item = step.closest('[data-tc-cd-key]');
      var input = item && item.querySelector('.line-item-qtys');
      if (!input || !$q()) { return; }
      var max = parseInt(input.getAttribute('max'), 10);
      var n = (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-tc-cd-step'), 10);
      if (n < 1) { n = 1; }
      if (max > 0 && n > max) { n = max; }
      if (String(n) === input.value) { return; }
      input.value = n;
      pendingFocus = { key: item.getAttribute('data-tc-cd-key'), step: step.getAttribute('data-tc-cd-step'), idx: [].indexOf.call(body.querySelectorAll('[data-tc-cd-key]'), item) };
      pendingMsg = 'Quantity updated to ' + n + '.';
      busy(true);
      $q()(input).trigger('change');
      return;
    }
    var rm = e.target.closest('.remove-item');
    if (rm) {
      pendingMsg = 'Removed ' + (rm.getAttribute('data-tc-cd-name') || 'item') + ' from your cart.';
      pendingFocus = { panel: true };
      busy(true);
      return;
    }
    var add = e.target.closest('[data-tc-cd-add]');
    if (add && !add.disabled && window.CartJS) {
      var name = add.getAttribute('data-tc-cd-name') || 'item';
      add.disabled = true;
      busy(true);
      pendingMsg = 'Added ' + name + ' to your cart.';
      pendingFocus = { panel: true };
      CartJS.addItem(parseInt(add.getAttribute('data-tc-cd-add'), 10), 1, {}, {
        success: function () { try { if (typeof fbq === 'function') { fbq('track', 'AddToCart'); } } catch (x) {} },
        error: function () {
          busy(false);
          add.disabled = false;
          pendingMsg = '';
          announce("Couldn't add " + name + '. It may have just sold out.');
        }
      });
    }
  });
  root.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('.line-item-qtys');
    if (!input) { return; }
    var max = parseInt(input.getAttribute('max'), 10);
    var n = parseInt(input.value, 10);
    if (isNaN(n) || n < 0) { n = 1; }
    if (max > 0 && n > max) { n = max; }
    input.value = n;
    if (!pendingMsg) {
      pendingMsg = n === 0 ? 'Item removed from your cart.' : 'Quantity updated to ' + n + '.';
      pendingFocus = n === 0 ? { panel: true } : { key: keyOf(input), input: true, idx: [].indexOf.call(body.querySelectorAll('[data-tc-cd-key]'), input.closest('[data-tc-cd-key]')) };
      busy(true);
    }
  }, true);

  function rendered() {
    var inner = body.querySelector('.tc-cd__in');
    if (!inner) { return; }
    if (loading && !addDone) { return; }
    if (loading) { setLoading(false); }
    var count = parseInt(inner.getAttribute('data-tc-cd-count'), 10);
    var total = inner.getAttribute('data-tc-cd-total') || '';
    var heads = root.querySelectorAll('.tc-cd__h .cart-item-count');
    for (var i = 0; i < heads.length; i++) { heads[i].textContent = count; }
    updateDispatch();
    express();
    busy(false);
    var msg = pendingMsg;
    if (!msg && lastCount !== null && count > lastCount) { msg = 'Added to your cart.'; }
    if (msg) {
      msg += count === 0 ? ' Your cart is empty.' : ' Your cart has ' + count + (count === 1 ? ' item' : ' items') + ', subtotal ' + total + '.';
      announce(msg);
    }
    lastCount = count;
    pendingMsg = '';
    var pf = pendingFocus;
    pendingFocus = null;
    if (pf && shown) {
      var target = null;
      if (pf.key) {
        var it = body.querySelector('[data-tc-cd-key="' + (window.CSS && CSS.escape ? CSS.escape(pf.key) : pf.key) + '"]');
        if (!it && pf.idx > -1) { it = body.querySelectorAll('[data-tc-cd-key]')[pf.idx] || null; }
        if (it) { target = pf.input ? it.querySelector('.line-item-qtys') : it.querySelector('[data-tc-cd-step="' + pf.step + '"]'); }
        if (target && target.disabled) { target = it.querySelector('.line-item-qtys'); }
      }
      if (!target) { target = panel; }
      try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
    }
  }
  if (window.MutationObserver) {
    new MutationObserver(rendered).observe(body, { childList: true });
  }
  rendered();
  sync();
})();

/* Quick-add links (a.add-cart with role="button" in product tiles, home and search cards) need Space to work like a button. */
document.addEventListener('keydown', function (e) {
  var a = e.target;
  if ((e.key === ' ' || e.key === 'Spacebar') && a && a.matches && a.matches('a.add-cart[role="button"]')) {
    e.preventDefault();
    a.click();
  }
});

/* Card clicks for measurement: quick-add vs opening the product from a card. Custom events reach web pixels that subscribe to them. */
document.addEventListener('click', function (e) {
  if (!(window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') || !e.target.closest) { return; }
  var p = location.pathname, source = p === '/' ? 'home' : p.indexOf('/collections') === 0 ? 'collection' : p.indexOf('/search') === 0 ? 'search' : 'other';
  var add = e.target.closest('a.add-cart');
  if (add) {
    Shopify.analytics.publish('tc_quick_add', { source: source, variant_id: add.getAttribute('data-variant-id'), product_url: add.getAttribute('href') });
    return;
  }
  var view = e.target.closest('.product-tile a[href*="/products/"], .tcx-card a[href*="/products/"], .tch-card a[href*="/products/"]');
  if (view) { Shopify.analytics.publish('tc_view_product_from_collection', { source: source, product_url: view.getAttribute('href') }); }
}, true);
